// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"a268413f","239":"a624ed0e","631":"cf32db28","788":"f1f6cbb5","830":"592d1240","849":"a14bd264"}[chunkId] + ".chunk.js";
};